import * as React from 'react'
import { useTranslate } from 'react-admin'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  useMediaQuery,
  useTheme
} from '@mui/material'
import dayjs from 'dayjs'
import { StatusTableCell } from '../../../helper/StatusTableCell'
import { CANCELLED, CONFIRMED, GENERATED, INVALIDATED } from '../../common/state'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'

export const DetailsJournalEntryModal = ({
  openModal,
  selectedItem,
  setOpenModal,
}) => {
  const theme = useTheme()
  const translate = useTranslate()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  const tableHeaders = [
    'number_journal_entry',
    'date',
    'amount',
    'status'
  ]

  const parseStatus = (status) => {
    if (status === CONFIRMED) {
      return GENERATED
    } else if (status === CANCELLED) {
      return INVALIDATED
    }

    return status
  }

  return (
    <div>
      <Dialog
        fullWidth
        maxWidth='md'
        fullScreen={fullScreen}
        open={openModal}
        onClose={() => setOpenModal(false)}
      >
        <DialogTitle>
          {`${translate('ra.field.detail')} ${translate('ra.field.provision').toLowerCase()}`}
        </DialogTitle>

        <DialogContent>
          <Table>
            <TableHead>
              <TableRow>
                {tableHeaders.map((header, i) => (
                  <TableCell key={i}>
                    {translate(`ra.field.${header}`)}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {selectedItem?.journal_entry?.map((entry, i) => (
                <TableRow key={i}>
                  <TableCell>{entry.nro}</TableCell>
                  <TableCell>{entry.date ? dayjs(entry.date).format('DD/MM/YYYY') : '-'}</TableCell>
                  <TableCell align='right'>{entry.currency} {numberFormatterWithDecimalAndThousand(entry.amount)}</TableCell>
                  <StatusTableCell data={parseStatus(entry.status)}/>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>

        <DialogActions style={{ display: 'flex' }}>
          <Button
            color='error'
            variant='outlined'
            onClick={() => {
              setOpenModal(false)
            }}
          >
            {translate('ra.action.close')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
